/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import { TicketType } from "@/components/event-ticket/TicketTypeManager";

/* eslint-disable */
export type EventInput = {
  is_free?: boolean;

  event_id?: string;
  event_title: string;
  event_description?: string;
  event_date: string;
  event_time?: string;
  start_time?: string;
  end_time?: string;
  location?: string;
  img_url?: string[];
  eventType?: EventInput.eventType;
  price?: string;
  tickets?: TicketType[];
  meeting_link?: string;
  account_type?: string;
  max_attendees?: string;
  ticket_price?: string;
  category: string;
  featured?: boolean;
  virtual_event?: boolean | string;
  /**
   * IANA timezone identifier
   */
  timezone?: string;
  schedule?: Array<{
    title?: string;
    startTime?: string;
    endTime?: string;
    description?: string;
    presenters?: Array<{
      name?: string;
      role?: string;
      company?: string;
      bio?: string;
    }>;
  }>;
  ticketTypes?: Array<{
    name?: string;
    description?: string;
    price?: number;
    maxQuantity?: number;
    saleStartDate?: string;
    saleEndDate?: string;
  }>;
  virtualEventUrl?: string;

  venue?: {
    name?: string;
    address?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    country?: string;
    latitude?: number;
    longitude?: number;
  };
  is_free?: boolean;
};

export namespace EventInput {
  export enum eventType {
    IN_PERSON = "in-person",
    VIRTUAL = "virtual",
    HYBRID = "hybrid",
    WEBINAR = "webinar",
    CONFERENCE = "conference",
    WORKSHOP = "workshop",
  }
}

export interface UploadMediaRequest {
  file_data: string;
  isBase64Encoded: boolean;
}

export interface InviteMembersRequest {
  email: string;

  role: string;
  first_name: string;
  last_name: string;
  custom_message?: string;
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export interface PaymentPro {
  account_type: string;
  subscription_type: string;
  subscription_price: string;
  months_valid: string;
  payment_method_id: string;
}
export interface EmailNotificationRequest {
  emailNotifications: boolean;
  marketingEmails: boolean;
}
export interface UpdateSettingsResponse {
  given_name: string;
  family_name: string;
  email: string;
  profile_description: string;
}
export interface TicketPurchasePayload {
  event_id: string;
  user_id: string;
  payment_method_id?: string;
  first_name: string;
  last_name: string;
  email: string[];
  phone_number: string;
  ticket_type?: string;
  ticket_price?: number;
  quantity: number;
  meeting_link?: string;
  location: string;
  // company_name: string;
  job_title?: string;
  // dietary_restrictions?: string;
  // questions_for_speakers?: string;
}
